module.exports = __webpack_public_path__ + "img/ocean.059e6958.svg";